export default __webpack_public_path__ + "static/media/pin-a2u-default.b147b7cb.svg";